export function filtrarTodosNosFiltros(data: TSelectData[]): TSelectData[] {
    const ultimoItem = data[data.length - 1];

    if (ultimoItem.label.toLowerCase() === "todos(as)") {
        return [ultimoItem];
    } else {
        return data.filter(item => item.label.toLowerCase() !== "todos(as)");
    }
}
type TSelectData = { id: number | null, label: string }

export function onChangeMultipleValue(valor: string[]) {
    const novoValor = valor.map(element => {
        const [id, label] = element.split(",")
        return { id: Number(id), label }
    });
    return novoValor.length > 0 ? filtrarTodosNosFiltros(novoValor) : [{ id: NaN, label: "Todos(as)" }]
}

export function filtrarTodosEmArrayDeStrings(arr: string[]): string[] {
    const ultimoItem = arr[arr.length - 1].toLowerCase() === "todos(as)";

    if (ultimoItem) {
        return ["Todos(as)"];
    } else {
        return arr.filter(item => item.toLowerCase() !== "todos(as)");
    }
}